var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_367_7053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3214 0.472656C9.62999 0.472656 9.07139 1.03125 9.07139 1.72266V2.47266C6.21983 3.05078 4.07139 5.57422 4.07139 8.59766V9.58984C4.07139 11.3633 3.46592 13.0859 2.36045 14.4688L1.77842 15.1992C1.55186 15.4805 1.50889 15.8672 1.66514 16.1914C1.82139 16.5156 2.14952 16.7227 2.50889 16.7227H18.1339C18.4933 16.7227 18.8214 16.5156 18.9776 16.1914C19.1339 15.8672 19.0909 15.4805 18.8644 15.1992L18.2823 14.4727C17.1769 13.0859 16.5714 11.3633 16.5714 9.58984V8.59766C16.5714 5.57422 14.423 3.05078 11.5714 2.47266V1.72266C11.5714 1.03125 11.0128 0.472656 10.3214 0.472656ZM10.3214 4.22266C12.7394 4.22266 14.6964 6.17969 14.6964 8.59766V9.58984C14.6964 11.4609 15.2394 13.2852 16.2472 14.8477H4.39561C5.40342 13.2852 5.94639 11.4609 5.94639 9.58984V8.59766C5.94639 6.17969 7.90342 4.22266 10.3214 4.22266ZM12.8214 17.9727H10.3214H7.82139C7.82139 18.6367 8.08311 19.2734 8.55186 19.7422C9.02061 20.2109 9.65733 20.4727 10.3214 20.4727C10.9855 20.4727 11.6222 20.2109 12.0909 19.7422C12.5597 19.2734 12.8214 18.6367 12.8214 17.9727Z",
    fill: "#191D34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_7053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.321289 0.472656)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellBold);
export default __webpack_public_path__ + "static/media/bell-bold.4f3113fb6c84420133f0205de34826a3.svg";
export { ForwardRef as ReactComponent };